import Vue from "vue";
import Router from "vue-router";
import admin from "./router/admin";
import protectWork from "./router/protectWork";
import dean from "./router/dean";
import login from "./router/login";
import thirdLogin from "./router/thirdLogin";
import report from "./router/report";
import redZone from "./router/redZone";
import portrait from "./router/portrait";
import superAdmin from "./router/superAdmin";
import NProgress from 'nprogress'
import aiShare from './router/aiShare'
import 'nprogress/nprogress.css'// nprogress样式文件

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

NProgress.configure({
	easing: 'ease',  // 动画方式    
	speed: 500,  // 递增进度条的速度    
	showSpinner: false, // 是否显示加载ico
	trickleSpeed: 200, // 自动递增间隔
	minimum: 1 // 初始化时的最小百分比
})

const router = new Router({
	routes: [
		login,
		thirdLogin,
		report,
		redZone,
		portrait,
		admin,
		protectWork,
		dean,
		superAdmin,
		aiShare
	]
})

//当路由开始跳转时
router.beforeEach((to, from, next) => {
	// 开启进度条
	NProgress.start();
	// 这个一定要加，没有next()页面不会跳转的。这部分还不清楚的去翻一下官网就明白了
	next();
});
//当路由跳转结束后
router.afterEach(() => {
	// 关闭进度条
	NProgress.done()
})

export default router;
